import React from 'react'
import Svg, { Path, Rect } from 'react-native-svg'
import { ColorValue } from 'react-native'

interface GiftIconProps {
  height?: number
  strokeColor1?: ColorValue
  strokeColor2?: ColorValue
  strokeColor3?: ColorValue
  strokeWidth?: number
  fillColor1?: ColorValue
  fillColor2?: ColorValue
}

const ASPECT_RATIO = 1.4

const GiftIcon = ({
  height = 96,
  strokeColor1 = '#E93F3F',
  strokeColor2 = '#D54A4A',
  strokeColor3 = '#BA3131',
  strokeWidth = 6,
  fillColor1 = '#FFD862',
  fillColor2 = '#F8D159',
}: GiftIconProps) => {
  const width = height * ASPECT_RATIO
  const rx = height / 7
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <Rect x="1" width={width - 2} height={height} rx={rx} fill={fillColor1} />
      <Path d={`M33 0V${height}`} stroke={strokeColor1} strokeWidth={strokeWidth} />
      <Path d={`M1 27L${width - 1} 26`} stroke={strokeColor1} strokeWidth={strokeWidth} />
      <Path
        d="M33 26L46 44"
        stroke={strokeColor2}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <Path
        d="M31 27L20 44"
        stroke={strokeColor2}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <Path
        d="M45 20C40 20 33 27 33 27C33 27 40 35 45 34C49 34 52 31 52 27C52 23 49 20 45 20Z"
        fill={fillColor2}
        stroke={strokeColor3}
        strokeWidth={strokeWidth}
      />
      <Path
        d="M20 20C25 20 32 27 32 27C32 27 25 35 20 34C16 34 12 31 12 27C12 23 16 20 20 20Z"
        fill={fillColor2}
        stroke={strokeColor3}
        strokeWidth={strokeWidth}
      />
    </Svg>
  )
}

export default GiftIcon
